import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {


  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.baseUrl + environment.url;
  }

  getBugData(projectId) {
    return this.http.get(this.url + '/bugReport/' + projectId)
  }

  getManageTestData(projectId) {
    return this.http.get(this.url + '/textData/' + projectId)
  }
  getSqlTestData(projectId) {//sqlQueryData
    return this.http.get(this.url + '/sqlQueryData/' + projectId)
  }
  getAutoItTestData(projectId) {
    return this.http.get(this.url + '/autoitscriptData/' + projectId)
  }

  getJavascriptTestData(projectId) {
    return this.http.get(this.url + '/javascriptData/' + projectId)
  }
  getPythonTestData(projectId) {
    return this.http.get(this.url + '/pythonscriptData/' + projectId)
  }

  addBugReport(data) {
    return this.http.post(this.url + '/bugReport', data);
  }

  updateBugReport(data) {
    return this.http.put(this.url + '/bugReport', data);
  }

  addAutoitscriptData(data) {
    return this.http.post(this.url + '/autoitscriptData', data);
  }

  updateAutoitscriptData(data) {
    return this.http.put(this.url + '/autoitscriptData', data);
  }

  addPythonScripts(data)
  {
    return this.http.post(this.url + "/pythonscriptData" , data)
  }

  updatePythonScripts(data)
  {
    return this.http.put(this.url + "/pythonscriptData" , data)
  }

  deleteBugData(projectId, id) {
    return this.http.delete(this.url + '/bugReport/' + projectId + '/' + id)
  }

  deleteTestData(projectId, id, name, settingName) {
    return this.http.delete(this.url + '/textData/' + projectId + '/' + id + '/' + name + '/' + settingName)
  }

  deleteSqlTestData(projectId, id) {
    return this.http.delete(this.url + '/sqlQueryData/' + projectId + '/' + id)
  }
  deleteAutoItTestData(projectId, id) {
    return this.http.delete(this.url + '/autoitscriptData/' + projectId + '/' + id)
  }

  deleteJavascriptTestData(projectId, id) {
    return this.http.delete(this.url + '/javascriptData/' + projectId + '/' + id)
  }
  deletePythonTestData(projectId, id) {
    return this.http.delete(this.url + '/pythonscriptData/' + projectId + '/' + id)
  }
}
